import { createAsyncThunk } from '@reduxjs/toolkit'
import { instance } from '../api/api'
import { GetNotificationsResponseType } from './types'

export const getAllNotifications = createAsyncThunk(
  'notifications/getAllNotifications',
  async (
    {
      token,
    }: {
      token: string
    },
    thunkAPI,
  ) => {
    try {
      const response = await instance.get<GetNotificationsResponseType>('notifications', {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue({
        errors: [error.message],
        fieldsErrors: undefined,
      })
    }
  },
)

export const readAllNotifications = createAsyncThunk(
  'notifications/mark-as-read',
  async (
    {
      token,
    }: {
      token: string
    },
    thunkAPI,
  ) => {
    try {
      const response = await instance.post<GetNotificationsResponseType>(
        'notifications/mark-as-read',
        { markAllAsRead: true },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue({
        errors: [error.message],
        fieldsErrors: undefined,
      })
    }
  },
)
